import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify'; // Ensure you have react-toastify installed
import { Api_Url } from '../../utils/ApiUrl';

const useAdminAllowed = () => {
    // console.log('Hello from useAdminAllowed', 1122);
 
    const history = useHistory();
    const [adminAllowed, setAdminAllowed] = useState(false);

    const Logout = useCallback(async () => {
        localStorage.removeItem("indexvalue");
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            history.push("/login");
            return;
        }
        const config = {
            method: "delete",
            url: `${Api_Url}/auth/users/logout`,
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };
        try {
            const response = await axios(config);
            if (response?.data?.statusCode === 200) {
                localStorage?.removeItem("accessToken");
                localStorage?.removeItem("refreshToken");
                localStorage?.removeItem("userName");
                history.push("/login");
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("accessToken");
                history.push("/login");
            }
        }
    }, [history]);

    const checkAdminStatus = useCallback(async () => {
        try {
            const accessToken = localStorage.getItem("accessToken");
            if (!accessToken) {
                return false;
            }
            const config = {
                method: 'get',
                url: `${Api_Url}/users/admin/status`,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            };
            const response = await axios(config);
            if (response?.data?.statusCode === 200 && response?.data?.data) {
                const { adminAccess, isActiveAdmin, primeAdmin } = response.data.data;
                if (adminAccess === 'WRITE' && isActiveAdmin) {
                    return true;
                } else if (adminAccess === 'READ' && isActiveAdmin) {
                    // toast.warn("You only have read access and cannot perform this action.");
                    return false;
                } else if (adminAccess === 'NONE' && primeAdmin) {
                    return true;
                } else {
                    if (!isActiveAdmin) {
                        toast.error("You are not authorized!");
                        Logout();
                    }
                    return false;
                }
            } else {
                return false;
            }
        } catch (error) {
            console.error("Error checking admin status:", error);
            if (error?.response?.status === 401) {
                Logout();
            }
            return false;
        }
    }, [Logout]);

    const handleCheckPermission = useCallback(async () => {
        const storedUser = localStorage.getItem("user");
        let isAdmin = false;
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                if (user?.primeAdmin) {
                    isAdmin = true;
                } else {
                    isAdmin = await checkAdminStatus();
                }
            } catch (error) {
                console.error("Error parsing user from localStorage:", error);
                isAdmin = await checkAdminStatus();
            }
        } else {
            isAdmin = await checkAdminStatus();
        }
        setAdminAllowed(isAdmin);
        return isAdmin;
    }, [checkAdminStatus, setAdminAllowed]);

    useEffect(() => {
        handleCheckPermission();
    }, [handleCheckPermission]);

    // Return the permission checking function and the boolean state
    return [handleCheckPermission, adminAllowed];
};

export default useAdminAllowed;
// import { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { useHistory } from 'react-router-dom';
// import { toast } from 'react-toastify'; // Ensure you have react-toastify installed
// import { Api_Url } from '../../utils/ApiUrl';



// const useAdminAllowed = () => {
//     console.log('Hello from useAdminAllowed',1122);
    
//     const history = useHistory();

//     const Logout = useCallback(async () => {
//         localStorage.removeItem("indexvalue");
//         const accessToken = localStorage.getItem("accessToken");
//         if (!accessToken) {
//             history.push("/login");
//             return;
//         }
//         const config = {
//             method: "delete",
//             url: `${Api_Url}/auth/users/logout`,
//             headers: {
//                 Authorization: `Bearer ${accessToken}`,
//             },
//         };
//         try {
//             const response = await axios(config);
//             if (response?.data?.statusCode === 200) {
//                 localStorage?.removeItem("accessToken");
//                 localStorage?.removeItem("refreshToken");
//                 localStorage?.removeItem("userName");
//                  history.push("/login");
//             }
//         } catch (error) {
//             if (error?.response?.status === 401) {
//                 localStorage.removeItem("accessToken");
//                  history.push("/login");
//             }
//         }
//     }, [history]);

//     const checkAdminStatus = useCallback(async () => {
//         try {
//             const accessToken = localStorage.getItem("accessToken");
//             if (!accessToken) {
//                 return false;
//             }
//             const config = {
//                 method: 'get',
//                 url: `${Api_Url}/users/admin/status`,
//                 headers: {
//                     Authorization: `Bearer ${accessToken}`,
//                 },
//             };
//             const response = await axios(config);
//             if (response?.data?.statusCode === 200 && response?.data?.data) {
//                 const { adminAccess, isActiveAdmin, primeAdmin } = response.data.data;
//                 if (adminAccess === 'WRITE' && isActiveAdmin) {
//                     return true;
//                 } else if (adminAccess === 'READ' && isActiveAdmin) {
//                     toast.warn("You only have read access and cannot perform this action.");
//                     return false;
//                 } else if (adminAccess === 'NONE' && primeAdmin) {
//                     return true;
//                 } else {
//                     if (!isActiveAdmin) {
//                         Logout();
//                     }
//                     return false;
//                 }
//             } else {
//                 return false;
//             }
//         } catch (error) {
//             console.error("Error checking admin status:", error);
//             if (error?.response?.status === 401) {
//                 Logout();
//             }
//             return false;
//         }
//     }, [Logout]);

//     const handleCheckPermission = useCallback(async () => {
//         const storedUser = localStorage.getItem("user");
//         if (storedUser) {
//             try {
//                 const user = JSON.parse(storedUser);
//                 if (user?.primeAdmin) {
//                     return true;
//                 } else {
//                     return await checkAdminStatus();
//                 }
//             } catch (error) {
//                 console.error("Error parsing user from localStorage:", error);
//                 return await checkAdminStatus();
//             }
//         } else {
//             return await checkAdminStatus();
//         }
//     }, [checkAdminStatus]);

//     // Return the permission checking function
//     return handleCheckPermission;
// };

// export default useAdminAllowed;